// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PartnersPage_icon__IsvIs {
  width: 48px;
  height: 48px;
  border-radius: var(--p-border-radius-200);
  object-fit: cover;
}

.PartnersPage_sectionLabel__9v3Mc {
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
`, "",{"version":3,"sources":["webpack://./src/partners-page/PartnersPage.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB","sourcesContent":[".icon {\n  width: 48px;\n  height: 48px;\n  border-radius: var(--p-border-radius-200);\n  object-fit: cover;\n}\n\n.sectionLabel {\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `PartnersPage_icon__IsvIs`,
	"sectionLabel": `PartnersPage_sectionLabel__9v3Mc`
};
export default ___CSS_LOADER_EXPORT___;
